import React from 'react'
import { Link } from 'react-router-dom'

function About() {
  return (
    <div>
<header className="text-gray-600 body-font  ">
  <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center ">
    <a className="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0">
    <img src='hackscript.png' className='logoimg'></img>
      <span className="ml-3 text-xl">HackScript</span>
    </a>
    <nav className=" md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-400	flex flex-wrap items-center text-base justify-center">
      <Link to = "/" className=' inline-flex items-center  text-gray-900 bg-gray-100 border-0 py-3 px-1 hover:bg-green-100'> Home</Link>
    </nav>

    < a href=''>
    <button className=" animated  inline-flex items-center  text-gray-900 bg-gray-100 border-0 py-3 px-1 focus:outline-none hover:bg-blue-900 hover:text-gray-100 rounded text-base mt-4 md:mt-0">
Buy Me a Coffee
    </button>
    </a>
  
  </div>
</header>

<h1 className='head text-gray-700'>Meet HackScript Founders ❤️ </h1>






    </div>
  )
}

export default About